import { CSSObject } from '@emotion/react';
import { mobile } from 'styles/media';

const form: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  width: 640,
  maxWidth: '100%',
  [mobile]: { width: '100%' },
};

const body: CSSObject = {
  maxHeight: 'calc(85vh - 200px)',
  overflowX: 'hidden',
  overflowY: 'auto',
  '> input, > textarea': { width: '100%' },
  '> p': { margin: '16px 0 8px', fontWeight: 600 },
  '> p:first-of-type': { marginTop: 0 },
  [mobile]: { maxHeight: 'calc(90vh - 200px)' },
};

const footer: CSSObject = {
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: 16,
  '> button': { height: 48, minWidth: 120, fontSize: 15 },
  [mobile]: { '> button': { flex: 1 } },
};

export { form, body, footer };
